import {
  ClipboardDocumentListIcon,
  ClipboardIcon,
} from '@heroicons/react/24/outline'
import { Button } from 'components/Button'
import { FormattedExportModal } from './FormattedExportModal'
import { useState } from 'react'
import { Transcript } from 'interfaces/db/transcript'

export const FormattedExport = ({
  submission_id,
  transcript,
}: {
  submission_id?: string
  transcript?: Transcript
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <>
      <Button
        onClick={() => setIsModalOpen(true)}
        icon={ClipboardDocumentListIcon}
        size="lg"
      >
        Formatted Copy
      </Button>
      <FormattedExportModal
        open={isModalOpen}
        setOpen={setIsModalOpen}
        submission_id={submission_id}
        transcript={transcript}
      />
    </>
  )
}
